/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { viewAccountDetail } from "../../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

const ReimbursementContactSucess = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];

  // Main title based on what was actually updated (sirf name update pe "Account name updated" dikhe)
  const hasContactUpdate = updatedFields.some((f) =>
    ["contact_no", "email_id"].includes(f),
  );
  const hasNameUpdate = updatedFields.includes("account_name");
  const hasLinkedUserUpdate = updatedFields.includes("linked_user");

  const getSuccessTitle = () => {
    if (hasNameUpdate && !hasContactUpdate && !hasLinkedUserUpdate)
      return "Account name updated successfully.";
    if (hasLinkedUserUpdate && !hasNameUpdate && !hasContactUpdate)
      return "User added successfully.";
    if (hasContactUpdate && !hasNameUpdate && !hasLinkedUserUpdate)
      return "Contact details updated successfully.";
    if (hasNameUpdate && (hasContactUpdate || hasLinkedUserUpdate))
      return "Account details updated successfully.";
    if (hasContactUpdate && hasLinkedUserUpdate)
      return "Contact details updated successfully.";
    return "Contact details updated successfully.";
  };

  const { viewAccountDetailData, viewAccountDetailError } = useSelector(
    (state) => state.ReimburseAccount,
  );
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: [],
    bank_account_holder_full_name: "",
  });

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard");
  };

  const createTxn = () => {
    // CommonToast({
    //   text: "Feature coming soon",
    //   icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
    //   variant: "var(--coming-soon)",
    //   buttonNeeded: false,
    // });
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
      {
        state: currentAccountDetails,
      },
    );
  };

  const beneficiaryAccount = viewAccountDetailData?.reimbursement_accounts?.[0];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["account_name", "contact_no", "email_id", "linked_user"];

  const fieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) => (acc?.name ? acc?.name : "Not available"),
    },
    contact_no: {
      leftSubTitle: "Contact number",
      icon: "https://q2pay.in/new_assets/common/create_flow/contact_number.svg",
      getTitle: (acc) =>
        acc?.contact_no ? `+91 ${acc.contact_no}` : "Not available",
    },
    email_id: {
      leftSubTitle: "Email ID",
      icon: "https://q2pay.in/new_assets/common/create_flow/gmail_red_error.svg",
      getTitle: (acc) => acc?.email_id || "Not available",
    },
    linked_user: {
      leftSubTitle: "Linked user",
      getTitle: (acc) =>
        acc?.reimbursement_user_full_name
          ? acc?.reimbursement_user_full_name
          : "Not linked",
    },
  };

  const renderInfoCards = () => {
    return fieldsToShow
      .filter((key) => fieldConfig[key])
      .map((key) => {
        const config = fieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            hoverable={
              key === "contact_no" || key === "email_id" ? "black" : undefined
            }
            rows={[
              {
                leftTitle: config.getTitle(beneficiaryAccount),
                leftSubTitle: config.leftSubTitle,
                ...(config.icon && { icon: config.icon }),
                ...(config.ifsc && { ifsc: beneficiaryAccount?.ifsc_code }),
              },
            ]}
          />
        );
      });
  };

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: () => {
          navigate(
            `/reimbursement_account_dashboard/create_reimbursement_account`,
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  useEffect(() => {
    if (viewAccountDetailError) {
      navigate("*");
    }
  }, [viewAccountDetailError]);

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    const account = viewAccountDetailData?.reimbursement_accounts?.[0];
    if (account) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = account;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels || [],
        bank_account_holder_full_name: name,
      });
    }
  }, [viewAccountDetailData]);

  return (
    <>
      <div>
        {" "}
        <StatusContainer
          status="success"
          hoverOption="white"
          buttonRows={buttonRows}
          title={getSuccessTitle()}
        >
          <TabsWeapperSection title="Account details">
            <>{renderInfoCards()}</>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default ReimbursementContactSucess;
